var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scout-form",
    {
      attrs: {
        "is-modified": !!_vm.value || _vm.value === 0,
        label: "最終ログイン",
      },
    },
    [
      _c("div", { staticClass: "boss-layout boss-layout-start" }, [
        _c("div", { staticStyle: { "min-width": "17em" } }, [
          _c("input", {
            staticClass: "boss-input",
            staticStyle: { width: "8em" },
            attrs: {
              placeholder: "0〜90から指定",
              type: "number",
              max: "90",
              min: "0",
              "data-test": "text-box",
            },
            domProps: { value: _vm.value },
            on: {
              keypress: function ($event) {
                return _vm.onlyNumberInRange($event, 90)
              },
              change: function ($event) {
                return _vm.$emit("input", $event.target.value || null)
              },
            },
          }),
          _vm._v(" "),
          _c("span", [_vm._v("日以内")]),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("span", { staticClass: "boss-annotation-text" }, [
            _vm._v(
              "\n        ※アクティブ会員を検索するための項目です（会員登録、ログイン、応募など）\n      "
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }